import { GA_TRACKING_ID } from 'config';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

export interface GoogleAnalyticsProps {}

ReactGA.initialize(GA_TRACKING_ID as string);

// this is a component instead of a hook so that it can be included dynamically
const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = () => {
  const location = useLocation();

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    ReactGA.send({ hitType: 'pageview', page });
  }, [location]);

  return null;
};

export default GoogleAnalytics;
